import { useState, useEffect, useCallback } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useAuth } from "AuthContext";

function AccountingReport() {
  const { token } = useAuth();
  const [rentals, setRentals] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchRentals = useCallback(() => {
    fetch(`/api/admin/accounting?startDate=${startDate}&endDate=${endDate}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setRentals(data);
        } else {
          console.error("❌ 報表資料格式錯誤或無權限:", data);
          setRentals([]);
        }
      })
      .catch(err => {
        console.error("❌ 取得報表失敗:", err);
        setRentals([]);
      });
  }, [startDate, endDate, token]);

  useEffect(() => {
    fetchRentals();
  }, [fetchRentals]);

  const columns = [
    { Header: "交易日期", accessor: "paymentTime", Cell: ({ value }) => new Date(value).toLocaleString() },
    { Header: "策略名稱", accessor: "strategy.title" },
    { Header: "創作者", accessor: "user_strategyrental_ownerIdTouser.fullName" },
    { Header: "租用者", accessor: "user_strategyrental_renterIdTouser.fullName" },
    { Header: "實付金額", accessor: "pricePaid" },
    { Header: "提成金額", accessor: "payoutAmount" },
    { Header: "交易序號", accessor: "paymentRef" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  財務報表與對帳中心
                </MDTypography>
                <MDBox display="flex" gap={2}>
                  <MDInput 
                    type="date" 
                    value={startDate} 
                    onChange={e => setStartDate(e.target.value)} 
                    size="small"
                  />
                  <MDInput 
                    type="date" 
                    value={endDate} 
                    onChange={e => setEndDate(e.target.value)} 
                    size="small"
                  />
                  <MDButton variant="contained" color="secondary" size="small" onClick={fetchRentals}>
                    篩選
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows: rentals }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AccountingReport;
